import React from 'react';
interface InputComponentProps {
  inputData: any;
  onChangeHandler: any;
  name: string;
  placeholder?: string;
  /**
   * What type of input, default is "text"
   */
  type?: string;
  /**
   * Mark if it's required or not
   */
  isRequired?: boolean;
  /**
   * Override the default styling
   */
  classes?: string;
}

export const Input: React.FC<InputComponentProps> = ({
  inputData,
  onChangeHandler,
  name,
  placeholder,
  type = 'text',
  isRequired,
  classes,
}) => {
  return (
    <>
      <input
        name={name}
        type={type}
        className={classes}
        value={inputData[name]}
        onChange={e =>
          onChangeHandler({ ...inputData, [name]: e.target.value })
        }
        placeholder={placeholder}
        {...(isRequired ? { required: true } : {})}
      />
    </>
  );
};
